var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTree87Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 49,
    viewBox: "0 0 66 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2299 29.68C54.2499 26.46 58.2899 23.85 62.8499 20.89L61.5699 18.84C51.1499 25.08 40.7399 31.45 34.7299 42.06C34.6899 24.77 42.3999 9.47 58.2999 16.61L59.1599 14.71C54.4199 12.54 49.0499 12.2 44.2999 14.08C44.2499 14.1 44.2099 14.12 44.1599 14.14C46.1599 11.45 48.4299 8.96 50.9799 6.75L50.1599 5.73999C44.1199 10.36 39.2099 16.48 35.8399 23.4C34.9499 25.23 34.1699 27.11 33.4999 29.04C30.3899 22.28 31.1799 9.35999 37.3099 2.01999L36.6499 1.42C34.0299 4.1 31.9799 7.83 30.7899 11.37C28.4699 7.24 23.4799 4.95999 18.9299 4.73999L18.8499 5.95C31.4999 8.22 29.3999 18.57 29.2199 22.06C24.7899 16.49 18.5299 12.09 11.0699 9.84999L10.5699 11.45C12.8599 12.19 15.0399 13.22 17.0999 14.45C12.7299 14.3 8.31988 15.37 4.49988 17.56L5.66988 19.56C20.8299 10.56 32.9299 23.83 31.1399 39.3C24.4099 30.59 14.0499 25.2 2.57988 24.9L2.48988 27.79C7.21988 28.06 11.2399 29.15 15.0199 30.91C8.51988 32.52 3.96988 37.03 2.12988 42.84L5.86988 43.97C7.10988 39.62 11.0799 35.44 15.9099 35.33C21.5899 35.2 25.0999 40.2 25.6099 40.96C27.4199 43.68 27.6999 46.44 27.7499 47.77C31.1199 47.94 34.4899 48.12 37.8599 48.29C37.2399 47.7 36.4299 46.72 36.2899 45.42C36.2099 44.63 36.2899 42.76 41.3399 38.48C45.0099 35.38 46.8299 33.78 48.9599 33.31C53.8299 32.23 58.9299 34.5 62.4999 38.43L65.0899 35.95C60.8199 31.71 55.4199 29.58 50.1999 29.67L50.2299 29.68Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4004 26.04C29.1404 25.73 27.6004 30.73 27.6004 30.73C27.6004 30.73 22.8604 32.77 22.4004 26.04Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6104 42C13.0104 35.4 17.4604 38.15 17.4604 38.15C17.4604 38.15 18.2404 43.26 11.6104 42Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4004 20.73C20.9904 16.96 22.2804 22.02 22.2804 22.02C22.2804 22.02 19.3004 26.23 15.4004 20.73Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83008 22.39C9.93008 17.04 12.7601 21.43 12.7601 21.43C12.7601 21.43 11.2701 26.37 5.83008 22.39Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 33.99C2.74 27.83 6.52 31.43 6.52 31.43C6.52 31.43 6.22 36.59 0 33.99Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8301 9.5C27.5501 8.97 26.1901 14.01 26.1901 14.01C26.1901 14.01 21.5201 16.21 20.8301 9.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9805 0C34.7005 6.17 29.4905 6.53999 29.4905 6.53999C29.4905 6.53999 25.8705 2.85 31.9805 0Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5498 14.07C39.2698 20.24 34.0598 20.61 34.0598 20.61C34.0598 20.61 30.4398 16.92 36.5498 14.07Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6201 26.05C43.6901 32.47 38.4701 32.3 38.4701 32.3C38.4701 32.3 35.2501 28.26 41.6201 26.05Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4696 8.36C53.5696 14.45 49.8896 10.74 49.8896 10.74C49.8896 10.74 50.3196 5.59 56.4696 8.36Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1902 17.06C50.7202 22.84 47.4102 18.8 47.4102 18.8C47.4102 18.8 48.3402 13.72 54.1902 17.06Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0902 22.07C47.6402 28.35 43.7002 24.93 43.7002 24.93C43.7002 24.93 43.7502 19.77 50.0902 22.07Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.96 38.05C49.51 42.03 48.04 37.02 48.04 37.02C48.04 37.02 50.87 32.7 54.96 38.05Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3496 27.99C59.5296 32.71 57.3496 27.96 57.3496 27.96C57.3496 27.96 59.5296 23.28 64.3496 27.99Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5001 8.56999C42.5201 15.24 37.9101 12.78 37.9101 12.78C37.9101 12.78 36.8101 7.72999 43.5001 8.56999Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8299 0.62999C43.9699 6.59999 38.7899 7.32999 38.7899 7.32999C38.7899 7.32999 34.9299 3.89999 40.8299 0.62999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree87Logo);
export default __webpack_public_path__ + "static/media/tree87logo.37128e7a88ffe0568bbd3117209711ba.svg";
export { ForwardRef as ReactComponent };